<template>
    <kb-container fluid class="top-padding bottom-padding no-horiz-padding">

        <subscriber-login-prompt/>

        <div class='curved-title-box' v-show='(searchType!="keyword")'>
            <div class='h2-size' v-if='(searchType!=="alltags" && searchType!=="mytags" && searchType!=="mylikes" && searchType!=="alllikes")'>{{searchPrompt}}</div>
            <div class='h2-size' v-if='(searchType==="alltags" || (searchType==="mytags" && isAuthenticated))'>Drafts <kb-form-select v-if='this.isAuthenticated' class="input-larger-text" v-model="searchType" :options='tagsSearchTypeOptions' @change='setSearchType'/> tagged as: <span class='bold-prompt'>{{tagName}}</span></div>
            <div class='h2-size' v-if='(searchType==="alllikes" || (searchType==="mylikes" && isAuthenticated))'>Drafts Liked by <span v-if='(!this.isAuthenticated)'>Anyone</span><kb-form-select v-if='this.isAuthenticated' class="input-larger-text" v-model="searchType" :options='likesSearchTypeOptions' @change='setSearchType'/></div>

            <div class='small-top-padding'  v-if='(searchType==="threading")'>These drafts <span v-if='!exactMatch' class='bold'>or their straightened/turned/point variants</span> can be woven on the same warp threading<span v-if='patternId===0'>:</span>
                <span v-if='patternId > 0'>&nbsp;as&nbsp;<router-link :to='this.draftDetailUrl'>#{{this.patternId}}</router-link>{{this.threadingSearchSubPrompt}}.</span>
                <div class='small-top-padding'>
                    <label><input class='checkbox' v-model="exactMatch" @change='onThreadingExactMatchChanged' type="checkbox" />&nbsp;Exact Matches Only</label>
                </div>
                <div class='top-padding' v-if='isSubscriber'>
                    <table v-if='isSubscriber && sampleDraft' ref='drawdown-table'>
                        <tr>
                            <td :style='getTableCellStyles(false, false)'>
                                <ruler :itemsCount='sampleDraft.WarpThreadsCount' startingSide='right' :cellPixelSize = 'cellPixelSize'
                                :lineThicknessPixels='borderThicknessPixels' />
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td :style='getTableCellStyles(false, false)'>
                                <!-- threading -->
                                <grid uniqueCanvasId='threadingGrid + drawdownRenderingKey' :rowsCount='sampleDraft.ShaftsCount'
                                :columnsCount='sampleDraft.WarpThreadsCount' :cellPixelSize='cellPixelSize'
                                :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' cellSelectedColor="#000000"
                                cellNotSelectedColor="#ffffff" :rowMajorArray="threading" :selectEntireColumns='false' :selectEntireRows='true'
                                :isReadOnly='true' :showInverse='false' :renderingKey='threadingRenderingKey' :drawLeftToRight='false' :drawTopToBottom='false'/>
                            </td>
                            <td :style='getTableCellStyles(false, false)'><ruler :itemsCount='sampleDraft.ShaftsCount' startingSide='bottom' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class='small-top-padding' v-if='(searchType==="tieup")'>These drafts <span class='bold'>or their straightened/turned/point variants</span> can be woven with the same tieup<span v-if='patternId===0'>:</span>
                <span v-if='patternId > 0'>as <router-link :to='this.draftDetailUrl'>#{{this.patternId}}</router-link>.</span>
                <div class='top-padding' v-if='isSubscriber'>
                    <table v-if='isSubscriber && sampleDraft' ref='drawdown-table'>
                        <tr>
                            <td :style='getTableCellStyles(false, false)'>
                                <ruler :itemsCount='sampleDraft.TreadlesCount' startingSide='left' :cellPixelSize = 'cellPixelSize'
                                :lineThicknessPixels='borderThicknessPixels' />
                            </td>
                            <td/>
                        </tr>
                        <tr>
                            <td :style='getDraftTableCellStyles(this.cellPixelSize, false, true)'>
                                <!-- tieup -->
                                <grid uniqueCanvasId='drawdownRenderingKey' :rowsCount='sampleDraft.ShaftsCount' :columnsCount='sampleDraft.TreadlesCount' :cellPixelSize='cellPixelSize'  :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' cellSelectedColor="#000000" cellNotSelectedColor="#ffffff" :rowMajorArray="tieup"  :selectEntireColumns='false' :selectEntireRows='false' :isReadOnly='true' :showInverse='false' :renderingKey='tieupRenderingKey' :drawLeftToRight='true' :drawTopToBottom='false'/>
                            </td>
                            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'><ruler :itemsCount='sampleDraft.ShaftsCount' startingSide='bottom' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
                        </tr>
                    </table>
                </div>
            </div>
            <div style='padding-top: 0.5rem;' v-show='(collectionDescription && collectionDescription.length > 0)'>
                <span v-html='collectionDescription'/>
                &nbsp;&nbsp;
                <span v-show='collectionOriginalSourceLinkUrl && collectionOriginalSourceLinkUrl.length > 0'>
                    <a target='_blank' :href='collectionOriginalSourceLinkUrl'>{{collectionOriginalSourceLinkText}}</a>
                    <br />
                </span>
                <hr style='padding-bottom: 0; margin-bottom: 0'/>
            </div>
        </div>

        <div v-if='((this.searchType==="clipboard") && totalResults && (totalResults > 0))'>
            <kb-button variant='default' @click="showClearBoardDialog">Clear Clipboard</kb-button>
        </div>

        <div v-if='(this.searchType=="board") && this.boardNotFound'>
            Board not found: <router-link to='/board-search?page=0'>Choose another board</router-link>
        </div>

        <div v-if='(this.userIsBoardOwner && (this.searchType==="board") && totalResults && (totalResults > 0))'>
            <kb-button variant='default' @click="showClearBoardDialog">Clear Board</kb-button>
        </div>

        <div v-if='(searchType=="clipboard" && !isAuthenticated)'>
            Please sign in to view your draft clipboard.
            <login-control prompt="Sign In Now" :show-as-link="false"/>
        </div>

        <div v-if='(searchType=="mytags" && !isAuthenticated)'>
            Please sign in to view your tagged drafts.
            <login-control prompt="Sign In Now" :show-as-link="false"/>
        </div>

        <div v-if='(searchType=="mylikes" && !isAuthenticated)'>
            Please sign in to view your liked drafts.
            <login-control prompt="Sign In Now" :show-as-link="false"/>
        </div>

        <kb-row v-if="!authRequiredAndMissing()">
            <kb-col v-if='(searchType==="category")' sm='7' class="small-top-padding">
                Category:<br />
                <kb-form-select v-model="selectedCategoryId" :options='categoryOptions' @change='setSelectedCollectionOrCategory($event)'/>
            </kb-col>
            <kb-col v-if='(searchType==="keyword")' sm='7' class="small-top-padding">
                Enter Optional Keyword or Draft ID:<br />
                <kb-form-group>
                    <kb-form-input class='right-margin' inline='true' inlineWidth='80%' type="text" v-model='keyword' @input='debounceKeywordInput'/>
                    <kb-form-group-append>
                        <kb-button variant='primary' @click='loadDraftsForKeyword' type="button">Search</kb-button>
                    </kb-form-group-append>
                </kb-form-group>
            </kb-col>
            <kb-col v-if='(searchType==="blocksize")'>
                Vertical&nbsp;Ends per Block:<br />
                    <kb-form-select v-model="verticalEndsPerBlock" :options='blockSizeOptions' @change='initializeComponentAtFirstPage("1")' />
                    <br/>
                Horizontal&nbsp;Ends per Block:<br />
                    <kb-form-select v-model="horizontalEndsPerBlock" :options='blockSizeOptions' @change='initializeComponentAtFirstPage("2")' />
            </kb-col>
            <kb-col v-if='!boardNotFound && searchType != "clipboard"' class="small-top-padding">
                <div v-if='searchType !== "threading" && searchType !== "tieup"' class='inline-auto-width small-horizontal-padding'>
                    Min&nbsp;Shafts:<br />
                    <kb-form-select :style='getFilterDropdownStyle(minShafts)' v-model="minShafts" :options='minShaftsOptions' @change='saveFiltersUserSettingsAndInitializeComponentAtFirstPage("3")' />
                </div>
                <div v-if='searchType !== "threading" && searchType !== "tieup"' class='inline-auto-width small-horizontal-padding'>
                    Max&nbsp;Shafts:<br />
                    <kb-form-select :style='getFilterDropdownStyle(maxShafts)' v-model="maxShafts" :options='maxShaftsOptions' @change='saveFiltersUserSettingsAndInitializeComponentAtFirstPage("4")' />
                </div>
                <div class='inline-auto-width small-horizontal-padding'>
                    Max&nbsp;Treadles:<br />
                    <kb-form-select :style='getFilterDropdownStyle(maxTreadles)' v-model="maxTreadles" :options='maxTreadlesOptions' @change='saveFiltersUserSettingsAndInitializeComponentAtFirstPage("5")' />
                </div>
                <div class='inline-auto-width small-horizontal-padding'>
                    Max&nbsp;Float:<br />
                    <kb-form-select :style='getFilterDropdownStyle(maxFloatLength)'  v-model="maxFloatLength" :options='maxFloatLengthOptions' @change='saveFiltersUserSettingsAndInitializeComponentAtFirstPage("6")' />
                </div>
                <a v-if='(this.minShafts > 0 || this.maxShafts > 0 || this.maxTreadles > 0 || this.maxFloatLength > 0)' href='#' @click='clearAllFilters'>Clear&nbsp;Filters</a>
            </kb-col>
        </kb-row>

        <div class="top-padding" v-if='(searchType==="surprise")'>
            <kb-button variant='default' v-if='searchType==="surprise"' @click="initializeComponentAtFirstPage('7')">Show More Random Drafts &raquo;</kb-button>
        </div>

        <draft-search-results v-if='!authRequiredAndMissing() && !boardNotFound' v-show='resultsVisible()'
        :show-share-button='this.searchType!=="clipboard" && this.searchType!=="mytags" && this.searchType!=="mylikes"'
        :patterns='patternsArray' :items-per-page='itemsPerPage' :initial-page-number="this.initialPageNum"
        :total-results='totalResults' :show-board-links="this.userIsBoardOwner"
        @pageNumberChanged='goToPage'
        @removeFromBoard='removeFromBoard'
        @thumbnailSizeChanged='onThumbnailSizeChanged' />

        <div v-if='(searchType==="surprise")'>
            <kb-button variant='default' v-if='searchType==="surprise"' @click="initializeComponentAtFirstPage('8')">Show More Random Drafts &raquo;</kb-button>
        </div>

        <div class="top-padding" v-if='(searchType=="category")'>
            <h4>Searching for Drafts by Category</h4>
            While we allow searching by category, most of the drafts on this site are not yet categorized and the list
            of categories needs revision.
        </div>

        <related-store-products :collectionId='selectedCollectionId' v-if='(searchType==="collection")'></related-store-products>

        <help-us-button/>
        <mail-chimp-signup/>
        <kb-modal auto-focus-button='cancel' ref='boardClearModalRef' title='Clear Board?' ok-title='Clear Board »' @ok='handleClearBoard' cancel-title='Cancel' @cancel='handleClearBoardCancel' :no-close-on-backdrop='true' :no-close-on-esc='true'>
            <div class="d-block text-center">
                Would you like to remove all the entries on your <span v-if='searchType==="clipboard"'>draft clipboard?</span><span v-if='searchType!=="clipboard"'>{{board ? board.Title : ''}} draft board?</span>
            </div>
        </kb-modal>

    </kb-container>
</template>

<script>
/* eslint-disable handle-callback-err */
import dataService from '../mixins/dataService.js'
import urlsService from '../mixins/urlsService'
import utilityService from '../mixins/utilityService'
import draftEditorService from '../mixins/draftEditorService'
import draftEditingUtils from '../mixins/draftEditingUtils'
import helpUsButton from './HelpUsButton.vue'
import mailChimpSignup from './MailChimpSignup.vue'
import draftSearchResults from './DraftSearchResults.vue'
import relatedStoreProducts from './RelatedStoreProducts'
import loginControl from './LoginControl.vue'
import ruler from './Ruler.vue'
import subscriberLoginPrompt from './SubscriberLoginPrompt.vue'
import grid from './Grid.vue'
import cfg from '../config/config.js'

export default {
    mixins: [dataService, urlsService, utilityService, draftEditorService, draftEditingUtils],
    data() {
        return {
            searchPrompt: '',
            threadingSearchSubPrompt: '',
            keyword: '',
            verticalEnds: 0,
            horizontalEnds: 0,
            selectedCollectionId: -1,
            selectedCategoryId: -1,
            collectionOptions: [],
            categoryOptions: [],
            collectionDescription: '',
            collectionOriginalSourceLinkUrl: '',
            collectionOriginalSourceLinkText: '',
            itemsPerPage: 0,
            initialPageNum: 0,
            patternsArray: [],
            totalResults: 0,
            minShafts: 0,
            maxShafts: 0,
            maxTreadles: 0,
            maxFloatLength: 0,
            patternId: 0,
            isTurned: false,
            isStraightened: false,
            isPointed: false,
            exactMatch: false,
            draftDetailUrl: '#',
            initialPageLoad: true,
            tagName: '',
            searchType: '',
            tagsSearchTypeOptions: [{ text: 'You', value: 'mytags' }, { text: 'Anyone', value: 'alltags' }],
            likesSearchTypeOptions: [{ text: 'You', value: 'mylikes' }, { text: 'Anyone', value: 'alllikes' }],
            boardId: 0,
            board: { BoardID: 0, Title: 'Clipboard', PatternsCount: 0, OwnerName: '' },
            boardNotFound: false,
            gridBorderColor: '#acacac',
            thumbnailSize: 4,
            borderThicknessPixels: 1,
            sampleDraft: { WarpThreadsCount: 1, ShaftsCount: 1 },
            threading: [false],
            threadingRenderingKey: '777',
            threadingHash: 0,
            tieup: [false],
            tieupRenderingKey: '777',
            tieupHash: 0,
            treadlingVariantName: '',
            threadingVariantName: '',
            verticalEndsPerBlock: 2,
            horizontalEndsPerBlock: 2
        }
    },
    methods: {

        generateNumericOptionsList(defaultPrompt, defaultValue, numericValuesArray) {
            let options = []
            options.push({ text: defaultPrompt, value: defaultValue })
            for (let c=0; c<numericValuesArray.length; c++) {
                let val = numericValuesArray[c]
                options.push({ text: val + '', value: val })
            }
            return options
        },

        getCurrentCollectionOption() {
            // console.log('in getCurrentCollectionOption')
            let currentSelection = this.findOptionWithValue(this.collectionOptions, this.selectedCollectionId)
            return currentSelection ? currentSelection : { value: 0, text: 'Not Found' }
        },

        getCurrentCategoryOption() {
            // console.log('in getCurrentCategoryOption')
            let currentSelection = this.findOptionWithValue(this.categoryOptions, this.selectedCategoryId)
            return currentSelection ? currentSelection : { value: 0, text: 'Not Found' }
        },

        goToPage(pageNumberEvent) {
            let pageNumber = pageNumberEvent.pageNumber
            this.initialPageNumber = pageNumber
            // console.log('in DraftSearch goToPage, pageNumber: ' + pageNumber)
            // console.log('in DraftSearch goToPage 1, query: ' + JSON.stringify(this.$route.query))
            // let q = this.getCurrentQuerystringCopy() // vue router won't pick up changes to the original object; a copy must be made
            // console.log('in DraftSearch goToPage 2, q: ' + JSON.stringify(q))
            this.setQuerystringValue('page', pageNumber).then(() => {
                // console.log('in DraftSearch goToPage 3, query: ' + JSON.stringify(this.$route.query))
                this.initializeComponent()
            })
        },

        authRequiredAndMissing() {
            if (this.searchType==='mytags' || this.searchType==='mylikes' || this.searchType==='clipboard') {
                return !this.isAuthenticated
            }
            else {
                return false
            }
        },

        removeFromBoard(removeEvent) {
            let patternId = removeEvent.patternId
            if (this.searchType==='clipboard') {
                this.deleteClipboardPattern(this.authUser.UserID, patternId, this.authUser.LoginToken).then(resp => {
                    this.initializeComponent()
                })
            }
            else if (this.searchType==='board' && this.userIsBoardOwner) {
                this.deleteUserBoardPattern(this.board.BoardID, patternId, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                    this.initializeComponent()
                })
            }
        },

        setSearchType() {
            if (this.searchType !== this.$route.params.searchType) {
                this.$route.params.searchType = this.searchType // tags and likes dropdowns allow search type change
                // eslint-disable-next-line node/handle-callback-err
                this.setQuerystringValue('searchType', this.searchType)
                this.$router.replace({ params: { searchType: this.searchType } }).then(() => {
                    this.initializeComponent()
                })
            }
        },

        clearAllFilters() {
            this.minShafts = 0
            this.maxShafts = 0
            this.maxTreadles = 0
            this.maxFloatLength = 0
            this.verticalEndsPerBlock = 0
            this.horizontalEndsPerBlock = 0
            this.initializeComponentAtFirstPage('0')
            this.saveAllFiltersUserSettings()
        },

        saveFiltersUserSettingsAndInitializeComponentAtFirstPage(source) {
            this.saveAllFiltersUserSettings()
            this.initializeComponentAtFirstPage(source)
        },

        saveAllFiltersUserSettings() {
            let userSettings = this.$store.state.authUserSettings
            // console.log('in saveAllFiltersUserSettings, this.minShafts: ' + this.minShafts)
            userSettings.MinShafts = this.minShafts
            userSettings.MaxShafts = this.maxShafts
            userSettings.MaxTreadles = this.maxTreadles
            userSettings.MaxFloatLength = this.maxFloatLength
            this.$store.commit('setFilters', userSettings)
            // console.log('user settings after update: ' + JSON.stringify(userSettings))
            this.putUserSettings(this.authUser.UserID, userSettings, this.authUser.LoginToken)
        },

        setSelectedCollectionOrCategory(newItemId) {
            // console.log('KB 777 setSelectedCollectionOrCategory: ' + newItemId)
            if (newItemId > 0) {
                let st = ''
                let p = Object.assign({}, this.$route.params) // vue router won't pick up changes to the original object; a copy must be made

                if (!newItemId) {
                    // console.log('setting newItemId to 0')
                    newItemId = 0
                }

                let q = this.getCurrentQuerystringCopy()

                q.page = '0'

                if (this.searchType === 'collection') {
                    p.searchType = 'collection'
                    p.bookOrCategoryId = newItemId

                    if (newItemId > 0) {
                        st = this.sanitizeUrlSegment(this.getCurrentCollectionOption(newItemId).text)
                        p.collectionTitle = st
                    }
                    else {
                        p.collectionTitle = null
                    }

                    // console.log('loadCollectionDescription 0')
                    this.loadCollectionDescription()
                }
                else if (this.searchType === 'category') {
                    p.searchType = 'category'
                    p.bookOrCategoryId = newItemId

                    if (newItemId > 0) {
                        st = this.sanitizeUrlSegment(this.getCurrentCategoryOption(newItemId).text)
                        st = st.slice(0, st.indexOf('('))
                        p.collectionTitle = st
                    }
                    else {
                        p.collectionTitle = null
                    }
                }
                // eslint-disable-next-line node/handle-callback-err
                this.$router.replace({ params: p, query: q }).catch(err => {
                    // console.log('error in setSelectedCollectionOrCategory: ' + JSON.stringify(err))
                }).then(() => {
                    this.initializeComponentAtFirstPage('9')
                })
            }
        },

        resultsVisible() {
            if (this.searchType === 'collection') {
                return (this.selectedCollectionId > 0)
            }
            if (this.searchType === 'category') {
                return (this.selectedCategoryId > 0)
            }
            if (this.searchType === 'keyword') {
                // return this.keyword.trim().length > 0
                return true
            }
            if (this.searchType === 'clipboard') {
                return this.isAuthenticated && this.patternsArray.length > 0
            }
            if (this.searchType === 'board') {
                return true
            }
            return true
        },

        initializeComponentAtFirstPage(label) {
            // console.log('in initializeComponentAtFirstPage, ' + label)
            let pageObj = { pageNumber: 0 }
            this.goToPage(pageObj)
        },

        initializeComponent() {
            // console.log('in initializeComponent')
            this.itemsPerPage = cfg.config.draftResultsPerPage
            this.initialPageNum = this.$route.query.page ? Number.parseInt(this.$route.query.page) : 0

            // on the initial page load only, default filters from user settings if logged in
            if (this.initialPageLoad) {
                this.searchType = this.$route.params.searchType
                if (this.isAuthenticated) {
                    this.minShafts = this.authUserSettings.MinShafts
                    this.maxShafts = this.authUserSettings.MaxShafts
                    this.maxTreadles = this.authUserSettings.MaxTreadles
                    this.maxFloatLength = this.authUserSettings.MaxFloatLength
                }
                this.initialPageLoad = false
            }

            this.patternId = this.$route.query.patternId ? Number.parseInt(this.$route.query.patternId) : 0
            this.threadingHash = this.$route.query.threadingHash ? this.$route.query.threadingHash : 0
            this.tieupHash = this.$route.query.tieupHash ? this.$route.query.tieupHash : 0
            this.isTurned = this.$route.query.isTurned ? (Number.parseInt(this.$route.query.isTurned) === 1) : false
            this.threadingVariantName = this.$route.query.threadingVariantName ? this.$route.query.threadingVariantName : ''
            this.treadlingVariantName = this.$route.query.treadlingVariantName ? this.$route.query.treadlingVariantName : ''
            this.isStraightened = this.$route.query.isStraightened ? (Number.parseInt(this.$route.query.isStraightened) === 1) : false
            this.isPointed = this.$route.query.isPointed ? (Number.parseInt(this.$route.query.isPointed) === 1) : false

            switch (this.searchType) {
                case 'collection': {
                    if (this.collectionOptions.length === 0) {
                        this.getCollectionsList().then(resp => {
                            this.collectionOptions = []

                            this.collectionOptions.push({ text: '(Select a Collection)', value: 0 })
                            for (let c=0; c < resp.data.length; c++) {
                                let collection = resp.data[c]
                                this.collectionOptions.push({ text: collection.TitleWithAuthors, value: collection.BookID })
                            }

                            this.selectedCollectionId = Number.parseInt(this.$route.params.bookOrCategoryId ? this.$route.params.bookOrCategoryId : 0)
                            if (!this.selectedCollectionId) { // can happen because the previous Angular version used "all" as a fake collection name when not specified
                                this.selectedCollectionId = 0
                            }

                            this.loadDraftsForSelectedCollection()
                            // console.log('loadCollectionDescription 1')
                            this.loadCollectionDescription()
                        })
                    }
                    else {
                        this.loadDraftsForSelectedCollection()
                        // console.log('loadCollectionDescription 2')
                        this.loadCollectionDescription()
                    }
                    break
                }

                case 'category': {
                    if (this.categoryOptions.length === 0) {
                        this.getCategoriesList().then(resp => {
                            this.categoryOptions = []

                            this.categoryOptions.push({ text: '(Select a category)', value: 0 })
                            for (let c=0; c< resp.data.length; c++) {
                                let category = resp.data[c]
                                this.categoryOptions.push({ text: category.Name + ' (' + category.DraftsCount + ' drafts)', value: category.ID })
                            }

                            this.selectedCategoryId = Number.parseInt(this.$route.params.bookOrCategoryId ? this.$route.params.bookOrCategoryId : 0)
                            if (!this.selectedCategoryId) { // can happen because the previous Angular version used "all" as a fake category name when not specified
                                this.selectedCategoryId = 0
                            }
                            this.loadDraftsForSelectedCategory()
                        })
                    }
                    else {
                        this.loadDraftsForSelectedCategory()
                    }
                    break
                }
                case 'alllikes': {
                    this.loadLikedDrafts(0)
                    break
                }
                case 'mylikes': {
                    this.loadLikedDrafts(this.authUser.UserID)
                    break
                }
                case 'alltags': {
                    let tagID = this.$route.params.bookOrCategoryId
                    let userID = 0 // all drafts associated with tags from everyone
                    this.getTag(tagID).then(resp => {
                        let tag = resp.data
                        this.tagName = tag.TagName
                        this.loadDraftsForSelectedTag(tagID, userID, tag.TagName)
                    })
                    break
                }
                case 'mytags': {
                    let tagID = this.$route.params.bookOrCategoryId
                    let userID = this.authUser.UserID // only drafts associated with tags that the current user assigned
                    this.getTag(tagID).then(resp => {
                        let tag = resp.data
                        this.tagName = tag.TagName
                        this.loadDraftsForSelectedTag(tagID, userID, tag.TagName)
                    })
                    break
                }
                case 'keyword': {
                    if (this.$route.query && this.$route.query.keyword) {
                        this.keyword = this.$route.query.keyword
                    }
                    this.loadDraftsForKeyword()
                    break
                }
                case 'popular': {
                    this.loadMostPopularDrafts()
                    break
                }
                case 'surprise': {
                    this.loadRandomDrafts()
                    break
                }
                case 'newest': {
                    this.loadNewestDrafts()
                    break
                }
                case 'clipboard': {
                    this.loadClipboardDrafts()
                    break
                }
                case 'board': {
                    this.boardId = Number.parseInt(this.$route.params.bookOrCategoryId)
                    // console.log('in DraftSearch board search, boardId: ' + this.boardId)
                    if (this.board===null || this.board.BoardID === 0) {
                        this.getUserBoard(this.boardId).then(resp => {
                            // console.log('board data returned: ' + JSON.stringify(resp.data))
                            this.board = resp.data
                            if (this.board) {
                                this.loadBoardDrafts()
                            }
                            else {
                                this.boardNotFound = true
                            }
                        })
                    }
                    else {
                        this.loadBoardDrafts()
                    }
                    break
                }
                case 'threading': {
                    this.thumbnailSize = this.getThumbnailDisplaySize()
                    if (this.patternId > 0) {
                        this.getPattern(this.patternId).then((resp) => {
                            this.searchPrompt = 'Drafts Matching Threading'
                            this.draftDetailUrl = this.buildDraftDetailUrl(resp.data)
                            if (this.isTurned && this.isStraightened) {
                                this.threadingSearchSubPrompt = ' turned and straightened'
                            }
                            else if (this.isTurned && this.isPointed) {
                                this.threadingSearchSubPrompt = ', turned and point threaded'
                            }
                            else if (this.isTurned) {
                                this.threadingSearchSubPrompt = ', turned'
                            }
                            else if (this.isStraightened) {
                                this.threadingSearchSubPrompt = ', straightened'
                            }
                            else if (this.isPointed) {
                                this.threadingSearchSubPrompt = ', point threaded'
                            }
                            if (this.isSubscriber) {
                                this.loadDraftJSONForThreadingDisplay()
                            }
                        })
                    }
                    else {
                        if (this.threadingSearchJSON) {
                            this.loadDraftJSONToArraysForDisplay(this.threadingSearchJSON)
                        }
                    }
                    this.loadMatchingThreadingDrafts()
                    break
                }
                case 'tieup': {
                    this.thumbnailSize = this.getThumbnailDisplaySize()
                    if (this.patternId > 0) {
                        this.getPattern(this.patternId).then((resp) => {
                            this.searchPrompt = 'Drafts Matching Tieup'
                            this.draftDetailUrl = this.buildDraftDetailUrl(resp.data)
                            if (this.isSubscriber) {
                                this.loadDraftJSONForThreadingDisplay()
                            }
                        })
                    }
                    else {
                        if (this.tieupSearchJSON) {
                            this.loadDraftJSONToArraysForDisplay(this.tieupSearchJSON)
                        }
                    }
                    this.loadMatchingTieupDrafts()
                    break
                }
                case 'blocksize': {
                    // console.log('in initializeComponent: blocksize')
                    this.loadDraftsForBlockSize()
                    break
                }
                case 'blocks': {
                    // console.log('in initializeComponent: blocks')
                    this.loadBlockDesignedDrafts()
                    break
                }
            }
        },

        loadCollectionDescription() {
            // console.log('loadCollectionDescription, selectedCollectionID: ' + JSON.stringify(this.selectedCollectionId))
            if (this.selectedCollectionId > 0) {
                this.getCollection(this.selectedCollectionId).then(resp => {
                    this.collectionDescription = resp.data.Description
                    this.collectionOriginalSourceLinkUrl = resp.data.OriginalSourceLinkUrl
                    this.collectionOriginalSourceLinkText = resp.data.OriginalSourceLinkText
                })
            }
        },

        loadDraftsForSelectedCategory() {
            this.searchPrompt = 'Drafts from Category: '
            this.searchPrompt += (this.selectedCategoryId > 0) ? this.getCurrentCategoryOption(this.selectedCategoryId).text : 'All Categories'
            let startingResult = this.calculateCurrentStartingResult()

            if (this.selectedCategoryId > 0) {
                this.getMatchingPatterns(0, 0, this.keyword, this.selectedCategoryId, '', this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                    this.totalResults = resp.data.TotalResults
                    this.patternsArray = resp.data.PatternsList
                })
            }
            else {
                this.totalResults = 0
                this.patternsArray = []
            }
        },

        loadDraftsForBlockSize() {
            let startingResult = this.calculateCurrentStartingResult()
            this.searchPrompt = 'Drafts formed from ' + this.verticalEndsPerBlock + 'x' + this.horizontalEndsPerBlock + ' blocks:'
            // console.log('in loadDraftsForBlockSize: h=' + this.horizontalEndsPerBlock + ', v=' + this.verticalEndsPerBlock)
            this.getBlockSizePatterns(this.verticalEndsPerBlock, this.horizontalEndsPerBlock, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadBlockDesignedDrafts() {
            let startingResult = this.calculateCurrentStartingResult()
            this.searchPrompt = 'Drafts Designed with Blocks'
            // console.log('in loadBlockDesignedDrafts: h=' + this.horizontalEndsPerBlock + ', v=' + this.verticalEndsPerBlock)
            this.getBlockDesignedPatterns(this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadDraftsForSelectedTag(tagID, userID) {
            // console.log('in loadDratsForSelectedTag, tagID: ' + tagID + ' userID: ' + userID)
            let startingResult = this.calculateCurrentStartingResult()
            this.getMatchingPatterns(userID, 0, this.keyword, '', tagID, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadDraftsForSelectedCollection() {
            this.searchPrompt = ''
            this.searchPrompt += (this.selectedCollectionId > 0) ? this.getCurrentCollectionOption(this.selectedCollectionId).text : 'Any Collection'
            let startingResult = this.calculateCurrentStartingResult()

            // console.log('in loadDraftsForSelectedCollection, minShafts: ' + this.minShafts)

            if (this.selectedCollectionId > 0) {
                // console.log('about to getMatchingPatterns, selectedCollectionId: ' + JSON.stringify(this.selectedCollectionId))
                this.getMatchingPatterns(0, this.selectedCollectionId, this.keyword, '', '', this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                    this.totalResults = resp.data.TotalResults
                    this.patternsArray = resp.data.PatternsList
                })
            }
            else {
                this.totalResults = 0
                this.patternsArray = []
            }
        },

        loadLikedDrafts(userID) {
            // console.log('in loadLikedDrafts, userID: ' + userID)
            if (this.isAuthenticated || this.searchType==='alllikes') {
                let startingResult = this.calculateCurrentStartingResult()
                this.getLikedPatterns(userID, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                    this.totalResults = resp.data.TotalResults
                    this.patternsArray = resp.data.PatternsList
                })
            }
        },

        debounceKeywordInput() {
            this.debounceInput(function() {
                this.loadDraftsForKeyword()
            }, 500)
        },

        loadDraftsForKeyword() {
            // searchPrompt isn't shown for keyword
            if (this.$route.query.keyword !== this.keyword) {
                this.setQuerystringValue('keyword', this.keyword)
            }
            let startingResult = this.calculateCurrentStartingResult()
            this.getMatchingPatterns(0, 0, this.keyword, '', '', this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadMostPopularDrafts() {
            this.searchPrompt = 'Most Popular Drafts'
            let startingResult = this.calculateCurrentStartingResult()
            this.getMostPopularPatterns(cfg.config.mostPopularResultsCount, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadRandomDrafts() {
            this.totalResults = 0
            this.patternsArray = []
            this.searchPrompt = 'Randomly Chosen Drafts'

            let randResultsCount = cfg.config.randomResultsCount
            let randWarpThreadCount = cfg.config.randomMaxWarpThreadsCount
            let randWeftThreadCount = cfg.config.randomMaxWarpThreadsCount

            this.getRandomPatterns(randResultsCount, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, randWarpThreadCount, randWeftThreadCount).then(resp => {
                this.totalResults = cfg.config.randomResultsCount
                this.patternsArray = resp.data
            })
        },

        loadNewestDrafts() {
            this.searchPrompt = 'Newest Drafts'
            let startingResult = this.calculateCurrentStartingResult()
            this.getNewestPatterns(cfg.config.newestResultsCount, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadMatchingThreadingDrafts() {
            let startingResult = this.calculateCurrentStartingResult()
            this.getMatchingThreadingPatterns(this.patternId, this.threadingHash, this.isTurned, this.isStraightened, this.isPointed, this.maxTreadles, this.maxFloatLength, this.exactMatch, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadMatchingTieupDrafts() {
            let startingResult = this.calculateCurrentStartingResult()
            this.getMatchingTieupPatterns(this.patternId, this.tieupHash, this.threadingVariantName, this.treadlingVariantName, this.isTurned, this.maxTreadles, this.maxFloatLength, startingResult, this.itemsPerPage).then(resp => {
                this.totalResults = resp.data.TotalResults
                this.patternsArray = resp.data.PatternsList
            })
        },

        loadClipboardDrafts() {
            let startingResult = this.calculateCurrentStartingResult()
            if (this.isAuthenticated) {
                this.getClipboardPatterns(this.authUser.UserID, this.itemsPerPage, startingResult).then(resp => {
                    this.totalResults = resp.data.TotalResults
                    this.patternsArray = resp.data.PatternsList
                    this.searchPrompt = 'Your Draft Clipboard'
                    if (this.patternsArray.length === 0) {
                        this.searchPrompt = '(Your Draft Clipboard is Empty)'
                    }
                })
            }
        },

        loadBoard(boardID) {
            this.getUserBoard(this.boardId).then(resp => {
                this.board = resp.data
            })
        },

        loadBoardDrafts() {
            let startingResult = this.calculateCurrentStartingResult()
            if (this.board != null) {
                this.getUserBoardPatterns(this.boardId, this.minShafts, this.maxShafts, this.maxTreadles, this.maxFloatLength, this.itemsPerPage, startingResult).then(resp => {
                    this.totalResults = resp.data.TotalResults
                    this.patternsArray = resp.data.PatternsList
                    // console.log('board: ' + JSON.stringify(this.board))
                    this.searchPrompt = this.board.Title + ', board by ' + this.board.OwnerName
                })
            }
        },

        handleClearBoard() {
            if (this.isAuthenticated) {
                if (this.searchType==='clipboard') {
                    this.clearClipboard(this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                        this.showClearBoardDialog(false)
                        this.initializeComponent()
                    })
                }
                else if (this.searchType==='board') {
                    if (this.userIsBoardOwner) {
                        this.deleteUserBoardPatterns(this.board.BoardID, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                            this.showClearBoardDialog(false)
                            this.initializeComponent()
                        })
                    }
                }
            }
        },

        showClearBoardDialog(isShow) {
            isShow ? this.$refs.boardClearModalRef.show() : this.$refs.boardClearModalRef.hide()
        },

        handleClearBoardCancel() {
            this.showClearBoardDialog(false)
        },

        calculateCurrentStartingResult() {
            return (this.initialPageNum * this.itemsPerPage) + 1 // paged pattern functions expect a startingResult that is 1-based, but maintained in Vue component state as 0-based
        },

        setThumbnailsSize() {
        },

        loadDraftJSONForThreadingDisplay() {
            if (this.searchType==='threading') {
                this.getPatternJson(this.patternId, this.isStraightened, false, this.isPointed, false, this.isTurned, false, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                    this.loadDraftJSONToArraysForDisplay(resp.data)
                })
            }
            else if (this.searchType==='tieup') {
                let threadingStraightened = (this.threadingVariantName === 's')
                let treadlingStraightened = (this.treadlingVariantName === 's')
                let threadingPointed = (this.threadingVariantName === 'p')
                let treadlingPointed = (this.treadlingVariantName === 'p')
                this.getPatternJson(this.patternId, threadingStraightened, treadlingStraightened, threadingPointed, treadlingPointed, this.isTurned, false, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                    this.loadDraftJSONToArraysForDisplay(resp.data)
                })
            }
        },

        loadDraftJSONToArraysForDisplay(draftJSON) {
            this.sampleDraft = draftJSON
            // load threading
            this.threading = new Array(this.sampleDraft.ShaftsCount)
            this.loadNativeOrderThreadingArrayFromDraftJSON(this.threading, this.sampleDraft)
            this.tieup = new Array(this.sampleDraft.ShaftsCount)
            this.loadNativeOrderTieupArrayFromDraftJSON(this.tieup, this.sampleDraft)
        },

        getThumbnailDisplaySize() {
            if (this.isAuthenticated) {
                // console.log('in thumbnailDisplaySize authenticated, returning: ' + this.$store.state.authUserSettings.ThumbnailSize)
                return this.$store.state.authUserSettings.ThumbnailSize
            }
            // console.log('in thumbnailDisplaySize nonauthenticated, returning: 1')
            return 1
        },

        onThumbnailSizeChanged(evt) {
            // console.log('in onThumbnailSizeChanged, evt: ' + JSON.stringify(evt))
            this.thumbnailSize = evt.size
        },

        onThreadingExactMatchChanged(evt) {
            this.initializeComponentAtFirstPage('onThreadingExactMatchChanged')
            this.loadMatchingThreadingDrafts()
        },

        getTableCellStyles(includeRightPadding, includeBottomPadding) {
            let tdStyle = ''
            if (includeRightPadding) {
                tdStyle += 'padding-right: ' + this.cellPixelSize + 'px;'
            }
            if (includeBottomPadding) {
                tdStyle += 'padding-bottom: ' + this.cellPixelSize + 'px;'
            }
            return tdStyle
        },

        generateNumbersArray(min, max) {
            let a = []
            for (let k=min; k<=max; k++) {
                a.push(k)
            }
            return a
        },

        getFilterDropdownStyle(dropdownValue) {
            if (dropdownValue > 0) {
                return 'background-color: rgb(191, 222, 238);'
            }
            else return ''
        }
    },

    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        draftSearchResults: draftSearchResults,
        relatedStoreProducts: relatedStoreProducts,
        loginControl: loginControl,
        subscriberLoginPrompt: subscriberLoginPrompt,
        grid: grid,
        ruler: ruler
    },

    watch: {
        'authUser.UserID': function(val) {
            // this.initializeComponentAtFirstPage('10')
        },
        '$route.params.searchType': function(val) {
            // console.log('searchType changed, about to initializeComponent from watcher')
            // console.log('new searchType: ' + val)
            // vue3 seems to have watchers fire even when the page is unloading to switch to another route...this check avoids that problem
            // without this, the page= querystring can get appended AFTER the switch to another route like /home
            if (val) {
                this.initializeComponentAtFirstPage('11')
            }
        },
        '$route.query.keyword': function(val) {
            this.initializeComponentAtFirstPage('12')
        }
    },

    computed: {
        authUser: function() {
            return this.$store.state.authUser
        },
        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },
        isSubscriber: function() {
            return this.$store.getters.isSubscriber
        },
        authUserSettings: function() {
            return this.$store.state.authUserSettings
        },
        threadingSearchJSON: function() {
            return this.$store.state.threadingSearchJSON
        },
        tieupSearchJSON: function() {
            return this.$store.state.tieupSearchJSON
        },
        minShaftsOptions: function() {
            return this.generateNumericOptionsList('Any', 0, this.generateNumbersArray(1, 96))
        },
        maxShaftsOptions: function() {
            return this.generateNumericOptionsList('Any', 0, this.generateNumbersArray(1, 96))
        },
        maxTreadlesOptions: function() {
            return this.generateNumericOptionsList('Any', 0, this.generateNumbersArray(1, 96))
        },
        maxFloatLengthOptions: function() {
            return this.generateNumericOptionsList('Any', 0, [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20])
        },
        blockSizeOptions: function() {
            return this.generateNumericOptionsList('2', 2, [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24])
        },
        userIsBoardOwner: function() {
            return (this.isAuthenticated && ((this.searchType==='board' && this.board && this.authUser.UserID === this.board.UserID) || (this.searchType === 'clipboard')))
        },
        cellPixelSize: function() {
            return this.thumbnailSize + 5
        }
    },
    mounted() {
        this.$store.commit('setPageTitle', 'Weaving Drafts Search')
        let initialPage = this.$route.query.page
        // console.log('in mounted, initial query: ' + JSON.stringify(this.$route.query))
        if (!initialPage) {
            initialPage = 0
        }
        this.goToPage({ pageNumber: initialPage }) // this will add any missing querystring parameters with default values
    }
}
</script>

<style scoped>
    .bold-prompt {
        font-weight: bold;
    }
    .input-larger-text {
        font-size: 1.75rem;
    }

    td {
        padding: 0;
        margin: 0;
        border: none;
        border-spacing: 0;
        border-collapse: collapse;
        line-height: 1px;
    }

    tr {
        padding: 0;
        margin: 0;
        border-spacing: 0;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    .prevent-scrolling-on-touch {
        touch-action: none
    }

    .curved-title-box {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        padding-bottom: 0.5rem;
        border-radius: 0.4rem;
        overflow: hidden;
        background-color: #f9f8f5;
        border: 1px solid #cfcfcf;
    }

</style>
